<!--
 * @Descripttion: DeepPay 在线支付页面
 * @Author: congz
 * @Date: 2020-06-11 11:08:34
 * @LastEditors: congz
 * @LastEditTime: 2020-08-18 23:15:35
-->

<template>
  <div class="payment">
    <div class="payment-content" v-if="order">
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="payment-clearfix">
          <span>Pay order</span>
        </div>
        <div class="payment-item">
          <div class="payment-tips">
            <span>Please complete payment using UPI</span>
          </div>
          <div class="payment-order-info">
            <div class="order-row">
              <span class="label">Order No:</span>
              <span class="value">{{ orderNum }}</span>
            </div>
            <div class="order-row">
              <span class="label">Amount:</span>
              <span class="value price">{{ order.discount_price * order.num }}₹</span>
            </div>
            <div class="order-row">
              <span class="label">Product:</span>
              <span class="value">{{ order.name }}</span>
            </div>
          </div>
          <!-- 支付二维码（DeepPay创单返回pay_url生成） -->
          <div v-if="payUrl" class="payment-qr">
            <div class="qr-tips">Scan QR code with any UPI app to pay</div>
            <img :src="qrImageUrl" class="qr-image" alt="UPI QR Code" />
            <div class="qr-waiting">Waiting for payment confirmation...</div>
          </div>
          <!-- 发起支付按钮 -->
          <div class="pay-operate" v-if="!payUrl">
            <div class="pay-btn">
              <el-button type="primary" @click="pay" :loading="payLoading">Pay Now</el-button>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="not-found" v-else>Unable to find the order</div>
  </div>
</template>
<script>
import * as ordersAPI from '@/api/orders'
import * as paymentAPI from '@/api/payment'
export default {
  name: 'Payment',
  data() {
    return {
      orderNum: '',
      order: '',
      payUrl: '',
      payLoading: false,
      pollingTimer: null
    }
  },
  computed: {
    qrImageUrl() {
      if (!this.payUrl) return ''
      return (
        'https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=' +
        encodeURIComponent(this.payUrl)
      )
    }
  },
  activated() {
    if (this.$route.query.orderNum != undefined) {
      this.orderNum = this.$route.query.orderNum
    }
  },
  watch: {
    // 监听订单号变化，请求后端获取订单数据
    orderNum: function() {
      this.load()
    }
  },
  methods: {
    load() {
      ordersAPI
        .showOrder(this.orderNum)
        .then(res => {
          if (res.status === 200) {
            this.order = res.data
            // 若订单已支付则跳回订单详情
            if (res.data.type === 2) {
              this.$router.push('/order/details?orderNum=' + this.orderNum)
            }
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed to obtain order', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain order', err)
        })
    },
    pay() {
      if (!this.order || !this.orderNum) {
        this.notifyError('Error', 'Order information not loaded')
        return
      }
      this.payLoading = true
      var form = {
        order_num: String(this.orderNum),
        amount: String(Math.round(this.order.discount_price * this.order.num)),
        nickname: this.order.address_name || 'Customer',
        phone: this.order.address_phone || '',
        email: this.order.address_email || ''
      }
      paymentAPI
        .initOnlinePayment(form)
        .then(res => {
          this.payLoading = false
          if (res.status === 200 && res.data && res.data.pay_url) {
            this.payUrl = res.data.pay_url
            this.startPolling()
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Payment initiation failed', res.msg)
          }
        })
        .catch(err => {
          this.payLoading = false
          this.notifyError('Payment initiation failed', err)
        })
    },
    startPolling() {
      var self = this
      this.pollingTimer = setInterval(function() {
        ordersAPI
          .showOrder(self.orderNum)
          .then(function(res) {
            if (res.status === 200 && res.data.type === 2) {
              clearInterval(self.pollingTimer)
              self.pollingTimer = null
              self.notifySucceed('Payment successful')
              setTimeout(function() {
                self.$router.push('/order/details?orderNum=' + self.orderNum)
              }, 1500)
            }
          })
          .catch(function() {})
      }, 5000)
    }
  },
  beforeDestroy() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    }
  },
  created() {},
  components: {}
}
</script>

<style scoped>
.payment .payment-content {
  width: 600px;
  margin: 0 auto;
  margin-bottom: 50px;
}
.payment .payment-content .payment-item .payment-tips {
  width: 500px;
  margin: 0 auto;
  text-align: center;
  color: #757575;
  padding: 10px 0 20px 0;
}
.payment .payment-content .payment-item .payment-order-info {
  width: 400px;
  margin: 0 auto;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}
.payment .payment-content .payment-item .payment-order-info .order-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e8e8e8;
}
.payment .payment-content .payment-item .payment-order-info .order-row:last-child {
  border-bottom: none;
}
.payment .payment-content .payment-item .payment-order-info .label {
  color: #666;
  font-size: 14px;
}
.payment .payment-content .payment-item .payment-order-info .value {
  color: #333;
  font-size: 14px;
  font-weight: 500;
}
.payment .payment-content .payment-item .payment-order-info .price {
  color: #8B5A2B;
  font-size: 18px;
  font-weight: bold;
}
.payment .payment-content .payment-item .payment-qr {
  text-align: center;
  margin-top: 30px;
}
.payment .payment-content .payment-item .payment-qr .qr-tips {
  color: #8B5A2B;
  font-size: 14px;
  margin-bottom: 15px;
  font-weight: 500;
}
.payment .payment-content .payment-item .payment-qr .qr-image {
  width: 250px;
  height: 250px;
  border: 2px solid #8B5A2B;
  border-radius: 8px;
  padding: 8px;
}
.payment .payment-content .payment-item .payment-qr .qr-waiting {
  color: #909399;
  font-size: 13px;
  margin-top: 15px;
}
.payment .payment-content .pay-operate {
  text-align: center;
  margin-top: 30px;
}
.payment .payment-content .pay-operate .pay-btn {
  display: inline-block;
}

.payment .not-found {
  height: 500px;
  text-align: center;
}
</style>
